import { Action } from 'redux';
import { SoaFormState } from '../interfaces/soa.interface';

/*
 * This payload state: soa
*/
export const SOA_STATE = 'soa';
const INITIAL_STATE: SoaFormState = {} as SoaFormState;
export class PayloadAction implements Action {
  type: string;
  partialState?: any;
}

export const PATCH_SOA_STATE = 'PATCH_SOA_STATE';
export const RESET_STATE = 'RESET_SOA_STATE';

export function patchSoaState(partialState: any): PayloadAction {
  return {
    type: PATCH_SOA_STATE,
    partialState: partialState
  };
}
export function resetSoaState(): PayloadAction {
  return {
    type: RESET_STATE
  };
}

export function soaState(state: SoaFormState = INITIAL_STATE, action: PayloadAction) {
  switch (action.type) {
    case PATCH_SOA_STATE:
        let copiedState = Object.assign({}, state);
        
        for (let key in action.partialState) {
          if (action.partialState.hasOwnProperty(key)) {
            copiedState[key] = action.partialState[key];
          }
        }

        return copiedState;
    case RESET_STATE:
        return INITIAL_STATE;
    default:
        return state;
  }
}

